import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=00f8c23c&"
import script from "./UserInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports